import React from 'react';
import PropTypes from 'prop-types';
import RulerTooltip from '../RulerTooltip';
import { pointPropType, rulerPropType } from '../../utils/proptypes';

var propTypes = {
  width: PropTypes.number.isRequired,
  height: PropTypes.number.isRequired,
  points: PropTypes.arrayOf(pointPropType).isRequired,
  ruler: rulerPropType.isRequired
};

var labelHeight = 24;

var calculateY = function calculateY(points, yTooltipPosition) {
  var pointsObject = {};

  var pointsSorted = [].concat(points).sort(function (a, b) {
    return a.y - b.y;
  });

  var prevPoint = void 0;
  for (var i = 0; i < pointsSorted.length; i += 1) {
    var realSpace = yTooltipPosition - pointsSorted[i].y;
    var neededSpace = (pointsSorted.length - i) * labelHeight;

    // move point upper if no space until the limit available
    if (realSpace < neededSpace) {
      var pointPos = yTooltipPosition - neededSpace;
      // if no upper room available stick it to 0
      prevPoint = pointPos >= 0 ? pointPos : 0;
      // move point lower if it overlaps the previous one
    } else if (prevPoint + labelHeight > pointsSorted[i].y) {
      prevPoint += labelHeight;
    } else {
      prevPoint = pointsSorted[i].y;
    }
    pointsObject[pointsSorted[i].name] = prevPoint;
  }

  return pointsObject;
};

var Ruler = function Ruler(_ref) {
  var ruler = _ref.ruler,
      points = _ref.points,
      height = _ref.height,
      width = _ref.width;

  var xTooltipMargin = 5;
  // The fixed position of a x-axis label which is the same for all highlighted points
  var xTooltipPosition = height - labelHeight - xTooltipMargin;
  var pointsObject = calculateY(points, xTooltipPosition);
  var firstPoint = points[0];

  return React.createElement(
    React.Fragment,
    null,
    React.createElement('line', {
      className: 'ruler-line',
      y1: 0,
      y2: height,
      stroke: '#ccc',
      strokeWidth: '1',
      x1: firstPoint.x,
      x2: firstPoint.x
    }),
    React.createElement(RulerTooltip, {
      labelHeight: labelHeight,
      color: firstPoint.color,
      label: ruler.timeLabel(firstPoint),
      x: firstPoint.x,
      y: xTooltipPosition,
      width: width
    }),
    points.map(function (point) {
      return [React.createElement(RulerTooltip, {
        key: point.name || point.y,
        labelHeight: labelHeight,
        color: point.color,
        label: ruler.yLabel(point),
        x: point.x,
        y: pointsObject[point.name] - labelHeight / 2,
        width: width
      }), React.createElement('circle', {
        key: 'circle' + (point.name || point.y),
        className: 'ruler-circle',
        r: 3,
        cx: point.x,
        cy: point.y,
        fill: point.color,
        stroke: point.color,
        strokeWidth: '3',
        strokeOpacity: '0.5'
      })];
    }),
    ';'
  );
};

Ruler.propTypes = process.env.NODE_ENV !== "production" ? propTypes : {};

export default Ruler;